import React, { useState } from "react";
import "./Navbar.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { useAuth } from "../../features/auth/AuthContext";
import { Link } from "react-router-dom";
import gpaLogo from "../../assets/G2.png";
import Menuicon from "../../assets/menu.png";
import CloseIcon from "../../assets/close.png"; // Close icon for mobile menu

function Navbar() {
  const { isLoggedIn, userData } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-bar-left">
          <span>
            <i className="fa fa-envelope" style={{ marginRight: "5px" }}></i>{" "}
            gpaichalkaranji@gmail.com
          </span>
        </div>
        <div className="top-bar-right">
          <div className="social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="navbar-new">
        <div className="company-logo">
          <img
            src={gpaLogo}
            alt="GPA Ichalkaranji"
            className="logo"
            height={"120px"}
            draggable="false" oncontextmenu="return false "
          />
          {/* <div class="logo-text">
            <p>GENERAL PRACTITIONER'S</p>
            <p>ASSOCIATION OF ICHALKARANJI</p>
          </div> */}
        </div>
        {/* Menu button with conditional rendering */}
        <div className="menu-btn" onClick={toggleSidebar}>
          <img src={Menuicon} alt="Menu" />
        </div>
        <ul className="menu-first">
          <li>
            <Link to="/" onClick={closeSidebar}>
              Home
            </Link>
          </li>
          <li className="menudropdown">
            <Link to="#">Activities</Link>
            {/* Dropdown */}
            <ul className="menudropdown-content">
              <li>
                <Link to="/activities/2019">2019</Link>
              </li>
              <li>
                <Link to="/activities/2020">2020</Link>
              </li>
              <li>
                <Link to="/activities/2021">2021</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/CommitteeMembers" onClick={closeSidebar}>
              Leadership Committee
            </Link>
          </li>
          <li>
            <Link to="/About" onClick={closeSidebar}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/Contact" onClick={closeSidebar}>
              Contact Us
            </Link>
          </li>
          <li>
            {isLoggedIn ? (
              <Link
                to="/profile"
                state={{ username: userData?.username }}
                onClick={closeSidebar}
              >
                Profile
              </Link>
            ) : (
              <Link className="login-btn" to="/login" onClick={closeSidebar}>
                Login
              </Link>
            )}
          </li>
        </ul>
        {/* Sidebar Content */}
        <div
          className={`navbar-navigation-content ${sidebarOpen ? "open" : ""}`}
        >
          {/* Close button inside the sidebar */}
          <button className="sidebar-close-btn" onClick={closeSidebar}>
            <img src={CloseIcon} alt="Close" />
          </button>
          <ul className="menu">
            <li>
              <Link to="/" onClick={closeSidebar}>
                Home
              </Link>
            </li>
            <li className="dropdown">
              <Link to="#">Activities</Link>
              {/* Dropdown */}
              <ul className="dropdown-content">
                <li>
                  <Link to="/activities/2019">2019</Link>
                </li>
                <li>
                  <Link to="/activities/2020">2020</Link>
                </li>
                <li>
                  <Link to="/activities/2021">2021</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/CommitteeMembers" onClick={closeSidebar}>
                Leadership Committee
              </Link>
            </li>
            <li>
              <Link to="/About" onClick={closeSidebar}>
                About
              </Link>
            </li>
            <li>
              <Link to="/Contact" onClick={closeSidebar}>
                Contact
              </Link>
            </li>
            <li>
              {isLoggedIn ? (
                <Link
                  to="/profile"
                  state={{ username: userData?.username }}
                  onClick={closeSidebar}
                >
                  Profile
                </Link>
              ) : (
                <Link className="login-btn" to="/login" onClick={closeSidebar}>
                  Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
